import React from 'react';
import { Grid, Fab, Dialog, Button, Divider, Avatar } from '@material-ui/core';
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'
import DatePicker from 'react-date-picker'
import Menu from '../../commons/Menu'
import PropTypes from 'prop-types'
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog'
import FromServer from '../../module/projects/FromServer';
import Ws from '../../providers/Ws';
import BugetEtapaTask from './BugetEtapaTask';

export default class InsertUpdateEtapa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideCalendar: false,
            hideCalendarFinish: false,
            dtDataStart: new Date(),
            dtDataFinish: new Date(),
            strDataStart: this.props.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: this.props.dictionary.proiecte.etapeProiect.selectDate,
            isOpenAlert: false,
            fullScreen: false,
            isOpenBuget: false,
            listBuget: []

        }
    }

    componentDidMount() {
        this.getWindowDimentions()

    }


    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }



    getLitereAvatar = (tx) => {

        // console.log('tx :', tx);

        if (tx !== null) {

            return tx.substring(0, 2)
        }
    }

    showData = (d) => {


        let u = new Utils()
        if (this.props.dictionary.data === 'en') {
            return u.dataPrescurtataEng(d)

        } else {
            return u.dataPrescurtataRomana(d)
        }
    }

    showCalendarStart = (s) => {

        // console.log('calendar subtaskSelectat :', s);
        // console.warn('new Date() :', new Date());
        let u = new Utils();

        let date = new Date()


        let durataDeLa = this.props.scop === 'Insert' ? new Date(s.durata_de_la) : new Date(u.ParseDataFromSql(s.durata_de_la))

        // console.log('object :', s.durata_de_la);

        this.setState({
            hideCalendar: true,
            hideCalendarFinish: false,
            dtDataStart: s.durata_de_la !== null ? durataDeLa : date,
            idSelectat: s.id
        })


    }

    showCalendarFinish = (s) => {
        // console.log('calendar subtaskSelectat :', s);
        // console.warn('new Date() :', new Date());
        let u = new Utils();


        let durataPanaLa = this.props.scop === 'Insert' ? new Date(s.durata_pana_la) : new Date(u.ParseDataFromSql(s.durata_pana_la))
        this.setState({
            hideCalendarFinish: true,
            hideCalendar: false,
            dtDataFinish: s.durata_pana_la !== null ? durataPanaLa : new Date(),
            idSelectat: s.id
        })


    }

    getPerioada = (s) => {
        let u = new Utils();

        let date = new Date()


        let durataDeLa = this.props.scop === 'Insert' ? new Date(s.durata_de_la) : new Date(u.ParseDataFromSql(s.durata_de_la))
        let durataPanaLa = this.props.scop === 'Insert' ? new Date(s.durata_pana_la) : new Date(u.ParseDataFromSql(s.durata_pana_la))

        this.setState({
            hideCalendarFinish: this.state.hideCalendarFinish ? false : true,
            hideCalendar: this.state.hideCalendar ? false : true,
            dtDataFinish: s.durata_pana_la !== null ? durataPanaLa : date,
            dtDataStart: s.durata_de_la !== null ? durataDeLa : date,
            idSelectat: s.id
        })
    }


    dataStartChange = async (ev) => {

        // console.warn('info proiect--------- :', this.props.proiectInfo);
        let fs = new FromServer();

        let u = new Utils()


        // console.log('ev data start :', ev);

        let dataChanghed = ''

        let dataEv = new Date(ev)
        dataEv = new Date(dataEv.setDate(dataEv.getDate() + 1))

        // console.log('dataSTart :', this.props.proiectInfo[0]);


        if (new Date(u.ParseDataFromSql(this.props.proiectInfo[0].perioada_dela)) <= dataEv && ev <= new Date(u.ParseDataFromSql(this.props.proiectInfo[0].perioada_panala))) {
            // console.log('etapeList :', this.props.etape);


            if (this.props.scop !== 'Insert') {
                let idx = this.props.etape.findIndex(i => i.id === this.props.etapaSelectata.id)




                //  console.log('filterEtape :', filterEtape);

                let okToInsert = 0


                if (idx === 0) {
                    okToInsert = 0
                } else if (ev < new Date(this.props.etape[idx - 1].durata_de_la)) {
                    okToInsert += 1
                }


                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(filterEtape[i].durata_de_la) && ev < new Date(filterEtape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }

                if (okToInsert !== 0) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //       console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else {
                    let obj = {
                        durata_de_la: u.transformDataForSql(ev)
                    }

                    //  console.log('obj :', obj);

                    let update = await fs.updateEtapa(obj, this.props.etapaSelectata.id)

                    if (update) {



                        this.setState({
                            dtDataStart: ev,


                        }, () => {
                            this.props.getData()
                            this.props.changeDataStart(obj.durata_de_la)
                        })

                    }
                }
            } else {
                let counter = this.props.etape.length

                let okToInsert = 0


                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(this.props.etape[i].durata_de_la) && ev < new Date(this.props.etape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }

                if (okToInsert !== 0) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //   console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else {






                    this.setState({
                        dtDataStart: ev,


                    }, () => {

                        this.props.changeDataStart(u.transformDataForSql(ev))
                    })


                }
            }


        } else {


            this.setState({
                isOpenAlert: true
            }, () => {
                //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }


    dataFinishChange = async (ev) => {
        let fs = new FromServer();

        let u = new Utils()

        // console.log('ev data start :', ev);

        let dataChanghed = ''

        // console.log('dataSTart :', this.props.proiectInfo[0]);


        if (new Date(u.ParseDataFromSql(this.props.proiectInfo[0].perioada_dela)) <= ev && ev <= new Date(u.ParseDataFromSql(this.props.proiectInfo[0].perioada_panala))) {
            //    console.log('etapeList :', this.props.etape);

            if (this.props.scop !== 'Insert') {

                let idx = this.props.etape.findIndex(i => i.id === this.props.etapaSelectata.id)

                // let counter = filterEtape.length


                //    console.log('filterEtape :', filterEtape);

                let okToInsert = 0

                if (idx === 0) {
                    if (ev >= new Date(new Date(this.props.etape[idx + 1].durata_pana_la).setDate(new Date(this.props.etape[idx + 1].durata_pana_la).getDate() - 1))) {
                        okToInsert += 1
                    } else {
                        okToInsert = 0
                    }
                } else if (ev < new Date(this.props.etape[idx - 1].durata_pana_la)) {
                    okToInsert += 1
                }



                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(filterEtape[i].durata_de_la) && ev < new Date(filterEtape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }

                if (okToInsert !== 0) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else {
                    let obj = {
                        durata_pana_la: u.transformDataForSql(ev)
                    }


                    let update = await fs.updateEtapa(obj, this.props.etapaSelectata.id)

                    if (update) {



                        this.setState({
                            dtDataFinish: ev,


                        }, () => {
                            this.props.getData()
                            this.props.changeDataFinish(obj.durata_pana_la)
                        })

                    }
                }
            }
            else {

                let counter = this.props.etape.length

                let okToInsert = 0

                for (let i = 0; i < counter; i++) {
                    if (ev > new Date(this.props.etape[i].durata_de_la) && ev < new Date(this.props.etape[i].durata_pana_la)) {
                        okToInsert += 1
                    }
                }

                if (okToInsert !== 0) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else {






                    this.setState({
                        dtDataFinish: ev,


                    }, () => {

                        this.props.changeDataFinish(u.transformDataForSql(ev))
                    })


                }

            }


        } else {


            this.setState({
                isOpenAlert: true
            }, () => {
                //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }


    openBugetEtapa = async () => {

        let ws = new Ws()
        let u = new Utils()

        let getBugete = await ws.customSelect('select * from costuri_etape where id_etapa = @p1 and isnull(sters,0) != 1', {
            p1: this.props.etapaSelectata.id
        })

        // console.warn('getBugete :', getBugete);
        if (getBugete.Succes) {

            let costuri = [...getBugete.Content]

            for (let i = 0, n = costuri.length; i < n; i++) {
                costuri[i].data_costului = u.ParseDataFromSql(costuri[i].data_costului)
            }

            this.setState({
                isOpenBuget: true,
                listBuget: costuri
            })
        }

    }


    numeConstChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].nume = ev.target.value

        this.setState({ listBuget: cloneCosturi })
    }

    valoareCostChange = (e, ev) => {

        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].valoare = ev.target.value

        this.setState({ listBuget: cloneCosturi })

    }

    dataCostChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].data_costului = ev.target.value

        this.setState({ listBuget: cloneCosturi })
    }

    updateNume = async (e) => {
        // console.log('v :', e);

        let ws = new Ws()

        let obj = {
            nume: e.nume
        }


        // console.log('obj :', obj);

        let updateN = await ws.update('costuri_etape', obj, { id: e.id })


    }

    updateValoareCost = async (v) => {
        // console.log('v :', v);

        let ws = new Ws()

        let obj = {
            valoare: v.valoare,

        }


        let updateBugete = await ws.update('costuri_etape', obj, { id: v.id })


    }

    updateDataCost = async (d) => {


        let ws = new Ws()

        let obj = {
            data_costului: d.data_costului,

        }


        let updateBugete = await ws.update('costuri_etape', obj, { id: d.id })

    }


    render() {
        return (
            <div>

                <Dialog


                    disableEscapeKeyDown
                    className='pm-task-dialog'
                    fullWidth={true}
                    maxWidth={'md'}
                    width={'md'}
                    fullScreen={this.state.fullScreen}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>

                    <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                        <i className='material-icons pm-round-button-text-dialog'>close</i>
                    </Fab>

                    <Grid container className='pm-insert-task-header'>




                        <Grid item xs={12} sm={12} md={8} lg={8} xl={8} style={{ marginBottom: 15 }} >
                            <div style={{ width: 'fit-content', padding: 5, border: '1px solid gray', margin: 'auto' }}>
                                <div style={{ position: 'relative', margin: 'auto', minWidth: 220, width: 'fit-content', border: '1px solid gray', padding: 5 }}>
                                    {/* <input type='text' value='' readOnly={true} className='pm-input-date-selector' onFocus={() => { this.showCalendarStart(this.props.etapaSelectata) }} />
                        <span className="pm-task-date-selector">{this.props.etapaSelectata.durata_de_la !== null ? this.showData(this.props.etapaSelectata.durata_de_la) : this.state.strDataStart} - </span>


                        <input type='text' value='' readOnly={true} style={{ maxWidth: 100 }} className='pm-input-date-selector' onFocus={() => { this.showCalendarFinish(this.props.etapaSelectata) }} />
                        <span className="pm-task-date-selector">{this.props.etapaSelectata.durata_pana_la !== null ? this.showData(this.props.etapaSelectata.durata_pana_la) : this.state.strDataFinish}</span> */}

                                    <span onClick={() => { this.getPerioada(this.props.etapaSelectata) }} className="pm-task-date-selector" style={{ display: 'block', textAlign: 'center', color: '#24bd24', fontWeight: 600, fontSize: 18 }}>Perioada Etapa:</span>
                                    <span style={{ display: 'block', textAlign: 'center' }} className="pm-task-date-selector" onClick={() => { this.getPerioada(this.props.etapaSelectata) }}>   <span style={{ color: '#7e7ee6', fontWeight: 500 }} >
                                        {
                                            this.props.etapaSelectata.durata_de_la !== null ?

                                                new Utils().dataPrescurtataRomana(this.props.etapaSelectata.durata_de_la)
                                                :
                                                ''
                                        } -  {

                                            this.props.etapaSelectata.durata_pana_la !== null ?
                                                new Utils().dataPrescurtataRomana(this.props.etapaSelectata.durata_pana_la)
                                                :
                                                ''
                                        }</span>
                                    </span>


                                    <div style={{ display: 'flex' }}>
                                        <div style={{ maxWidth: 220, marginRight: 10 }}>
                                            <Calendar

                                                className={this.state.hideCalendar ? '' : 'pm-hide-calendar'}
                                                locale={this.props.dictionary.date}
                                                onChange={(ev) => { this.dataStartChange(ev) }}
                                                value={this.state.dtDataStart}
                                            />
                                        </div>

                                        <div style={{ maxWidth: 220 }}>
                                            <Calendar

                                                className={this.state.hideCalendarFinish ? '' : 'pm-hide-calendar-finish'}
                                                locale={this.props.dictionary.date}
                                                onChange={(ev) => { this.dataFinishChange(ev) }}
                                                value={this.state.dtDataFinish}
                                            />
                                        </div>


                                    </div>




                                </div>

                                <div style={{ display: 'flex', margin: 'auto', width: 220, marginTop: 15, justifyContent: 'center', border: '1px solid gray', padding: 5 }}>
                                    <div style={{ marginRight: 10 }}>
                                        <span className='pm-table-header-label'>{this.props.dictionary.proiecte.etapeProiect.deLaOra}</span>
                                        <input className='pm-task-time-input' type='time' value={this.props.candOra || '00:00'} onChange={this.props.candOraChange} />

                                    </div>
                                    <div>
                                        <span className='pm-table-header-label'>{this.props.dictionary.proiecte.etapeProiect.panaLaOra}</span>
                                        <input className='pm-task-time-input' type='time' value={this.props.panaCandOra || '00:00'} onChange={this.props.panaCandOraChange} />

                                    </div>


                                </div>

                            </div>
                        </Grid>


                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <div style={{ position: 'relative', margin: 'auto', minWidth: 220, width: 'fit-content', border: '1px solid gray', padding: 5 }}>
                                <span className="pm-task-date-selector" style={{ display: 'block', textAlign: 'center', color: 'rgb(179, 109, 47)', fontWeight: 600, fontSize: 18 }}>Perioada Proiect</span>
                                <span style={{ color: '#7e7ee6', fontWeight: 500 }} >  {new Utils().dataPrescurtataRomana(new Utils().ParseDataFromSql(this.props.proiectInfo[0].perioada_dela))} -  {new Utils().dataPrescurtataRomana(new Utils().ParseDataFromSql(this.props.proiectInfo[0].perioada_panala))}</span>
                            </div>
                            <div>
                                {this.props.scop !== 'Insert' &&
                                    <Button style={{ verticalAlign: 'inherit', marginTop: 10, backgroundColor: '#ca1c1cd6', color:'white' }}   color="primary" onClick={this.props.stergeEtapa}>
                                        <i style={{ marginRight: 5 }} className='material-icons'>delete</i>   Sterge Etapa
                                    </Button>
                                }

                            </div>
                        </Grid>

                        {this.props.scop !== 'Insert' &&
                            <Grid style={{ textAlign: 'right' }} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Button style={{ verticalAlign: 'inherit', marginTop: 10, backgroundColor: '#d88f0b' }} variant="outlined" className='pm-completed-task-button' color="primary" onClick={this.props.openListDocumente}>
                                    <i style={{ marginRight: 5 }} className='material-icons'>description</i>   {this.props.dictionary.proiecte.etapeProiect.documenteEtape}
                                </Button>
                                <div style={{ textAlign: 'right' }}>
                                    <Button style={{ verticalAlign: 'inherit', marginTop: 10, backgroundColor: 'blue' }} variant="outlined" className='pm-edit-button' color="primary" onClick={this.openBugetEtapa}>
                                        <i style={{ marginRight: 5 }} className='material-icons'>attach_money</i>  Buget Etapa
                                </Button>
                                </div>


                            </Grid>
                        }

                        <Grid className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >


                            <div style={{ width: '100%', height: '100%', position: 'relative', cursor: 'pointer' }}>
                                <span className='pm-table-header-label'>{this.props.dictionary.proiecte.etapeProiect.responsabil}</span>

                                {this.props.etapaSelectata.nume &&
                                    <div>
                                        {
                                            this.props.etapaSelectata.poza &&
                                            <div
                                                className='pm-angajati-picture'
                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + this.props.etapaSelectata.poza}')` }}>

                                            </div>
                                        }
                                        {!this.props.etapaSelectata.poza &&
                                            <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(this.props.etapaSelectata.nume + ' ')} </Avatar>
                                        }
                                        <span onClick={this.props.userClick} className='pm-task-change-user'>{this.props.etapaSelectata.nume}</span>

                                    </div>
                                }
                                {!this.props.etapaSelectata.nume &&
                                    <Button style={{
                                        margin: 'auto',
                                        display: 'block',
                                        textAlign: 'left',
                                        backgroundColor: '#c6ccc68a',
                                        color: '#12821c',
                                        width: '100%'
                                    }} onClick={this.props.userClick} >
                                        Click pentru resonsabil etapa
                                </Button>
                                }
                                <Menu
                                    openMenu={this.props.isUtlizatorOpen}
                                    e={{ id: 3 }}
                                    elSelectat={{ id: 3 }}
                                    closeMenu={this.props.closeUtilizator}
                                    el={this.props.listUsers}
                                    text={'nume'} />
                            </div>
                        </Grid>



                        <Grid style={{ position: 'relative' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <span className='pm-etapa-label-input'>{this.props.dictionary.proiecte.etapeProiect.denumire}:</span>
                            <input className='pm-etapa-nume-input' type='text' value={this.props.numeEtapa || ''} onChange={this.props.numeEtapaChange} />

                        </Grid>

                        <Grid style={{ position: 'relative' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <span className='pm-etapa-label-input'>{this.props.dictionary.proiecte.etapeProiect.descriereTask}:</span>
                            <textarea rows={7} className='pm-etapa-descriere-input' type='text' value={this.props.descriereEtapa || ''} onChange={this.props.descriereEtapaChange}  >
                            </textarea>

                        </Grid>

                        <Grid style={{ textAlign: 'right' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Button variant="outlined" className='pm-save-etapa-button' color="primary" onClick={this.props.scop === 'Insert' ? this.props.insertEtapa : this.props.salveazaEtapa}>
                                {this.props.dictionary.comune.save}
                            </Button>
                        </Grid>


                    </Grid>



                    <BugetEtapaTask
                        open={this.state.isOpenBuget}
                        scop={'etapa'}
                        idEtapa={this.props.etapaSelectata.id}
                        title={'Buget Etapa ' + this.props.numeEtapa}
                        dialogClose={() => { this.setState({ isOpenBuget: false }) }}
                        costuriEtapa={this.state.listBuget}
                        numeConstChange={this.numeConstChange}
                        updateNume={this.updateNume}
                        valoareCostChange={this.valoareCostChange}
                        updateValoareCost={this.updateValoareCost}
                        dataCostChange={this.dataCostChange}
                        updateDataCost={this.updateDataCost}
                        getData={this.openBugetEtapa}
                    />




                    <AlertDialog
                        open={this.state.isOpenAlert}
                        dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                        title={this.props.dictionary.alertDate.etapa}
                        limba={this.props.dictionary}
                        yesFunction={() => { this.setState({ isOpenAlert: false }) }}
                        noButtonDisplay={1}
                    />





                </Dialog>
            </div>
        );
    }
}


InsertUpdateEtapa.propType = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    dictionary: PropTypes.object,
    numeEtapa: PropTypes.string,
    descriereEtapa: PropTypes.string,
    numeEtapaChange: PropTypes.func,
    descriereEtapaChange: PropTypes.func,
    salveazaEtapa: PropTypes.func,
    insertEtapa: PropTypes.func,
    scop: PropTypes.string,
    etapaSelectata: PropTypes.object,
    proiectInfo: PropTypes.array,
    etape: PropTypes.array,
    getData: PropTypes.func,
    changeDataStart: PropTypes.func,
    changeDataFinish: PropTypes.func,
    userClick: PropTypes.func,
    closeUtilizator: PropTypes.func,
    listUsers: PropTypes.array,


}

